import React, { HTMLAttributes } from 'react'
import styled, { css } from 'styled-components'
import Container from '@components/Container'
import Box from '@components/Box'
import { SH1, STypographyParagraph } from '@components/Typography'
import { SButton } from '@components/Button/Button'
import { above } from '@styles/mixins/breakpoints'

const SContainer = styled(Container)`
  overflow-y: hidden;
  min-height: 500px;
  padding-top: 24px;
  padding-bottom: 20px;
  position: relative;

  ${above('md')(css`
    display: flex;
    min-height: 380px;
    padding-top: 60px;
    padding-right: 276px;
    padding-left: 40px;
    padding-bottom: 2px;
  `)}

  ${above('xl')(css`
    padding-top: 0px;
    padding-bottom: 0px;
    padding-right: 10px;
    padding-left: 10px;
  `)}
`

const SBannerButton = styled(SButton)`
  justify-content: center;
  margin-top: auto;
  width: 100%;

  ${above('md')(css`
    min-width: 182px;
    width: auto;
    max-height: 52px;
  `)}
`

interface IProps extends HTMLAttributes<HTMLDivElement> {
  title: string
  text: string
  link: {
    handle: () => void
    text: string
  }
  image?: string
  children?: JSX.Element
}

const Banner: React.FC<IProps> = ({ title, text, link, image, children, ...containerProps }) => {
  return (
    <SContainer {...containerProps}>
      <Box
        className="bannerContentContainer"
        width={{ _: '100%', md: '452px', xl: '580px' }}
        minHeight={{ xs: '456px', md: '380px' }}
        display="flex"
        flexDirection="column"
        justifyContent={{ xs: 'space-between', md: 'flex-start', xl: 'center' }}
        alignItems={{ xs: 'center', md: 'flex-start' }}
        position="relative"
        zIndex={1}
      >
        <Box width="100%">
          <SH1 className="bannerTitle" color="graphite" mb={{ _: '8px', md: '16px' }}>
            {title}
          </SH1>
          <STypographyParagraph
            mr={{ xs: '40px', md: 0 }}
            mb={{ _: '8px', md: '24px', xl: '32px' }}
            className="bannerText"
            color="graphite"
            dangerouslySetInnerHTML={{ __html: text }}
          />
          {children}
        </Box>
        <Box display="flex" width={{ xs: '100%', md: 'auto' }} flexDirection={{ xs: 'column', md: 'row' }}>
          {link && (
            <SBannerButton mb={{ xs: '26px', md: 0 }} onClick={link.handle}>
              {link.text}
            </SBannerButton>
          )}
        </Box>
      </Box>
    </SContainer>
  )
}

export default Banner
